module.exports = __webpack_public_path__ + "img/logo.baa7cc6c.png";